import Heading from '@components/web/heading/Heading.tsx';
import SubHeading from '@components/web/heading/SubHeading.tsx';
import RFTrigger from '@/form/register/RFTrigger.tsx';
import barImg from '@/assets/img/Overons/bar-chart.png';

const OverOns = () => {
  return (
    <div id="over-ons" className="scroller">
      <Heading title="Over Ons" />

      <section className="container pt-20 pb-10">
        <div className="grid grid-cols-2 gap-8 items-start">
          {/* Left column: text block 1 */}
          <div>
            <div className="mb-10">
              <SubHeading title="De oplossing om te groeien" />
              <p className="text-sm mt-5">
                Er is een groot marktpotentieel maar beperkte groeimogelijkheden
                binnen de bestaande muren bij vele Dienstencheque bedrijven. Dat
                was voor Solvere, dé aanleiding om uit te kijken naar een op
                maat gemaakte en betaalbare easy-to-use applicatie voor deze
                bedrijven.
              </p>
            </div>
            <div>
              <img
                src={barImg}
                alt="chart reference"
                className="w-full max-w-[900px] h-auto"
              />
            </div>
          </div>

          <div>
            <div className="mb-10">
              <SubHeading title="Solvere is uw software op maat" />
              <p className="text-sm mt-5">
                We hanteren een succesformule van nauwe samenwerking met
                verschillende Dienstencheque bedrijven. Daardoor zijn wij bekend
                met de problematieken binnen deze bedrijven.
              </p>
              <p className="text-sm">
                Wij ontwikkelen rond de noden van de dienstencheque bedrijven en
                de mensen en zorgen voor een naadloze integratie. Verder hechten
                wij veel belang aan een goede opvolging en langdurig
                partnership.
              </p>
            </div>

            <div>
              <SubHeading title="Bespaar heel wat geld uit!" />
              <p className="text-sm mt-5">
                Solvere gebruiken verbetert de efficiëntie en bespaart u geld
                uit! Verminder de onnodige kosten en ga van start met u te
                concentreren op meer belangrijke taken. Dit alles leidt tot een
                goede dienstverlening, wat weer leidt naar meer rust en
                rendement.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className=" bg-[#f5f5f5] mb-[175px] border-t border-[#eff0f0] text-center py-16">
        <div className="container">
          <h2 className="text-[32px] md:text-[50px] leading-tight text-[#5a6b78] mb-6">
            Nog niet overtuigd?
          </h2>

          <p className="text-[20px] text-[#666666] mx-auto mb-3">
            Vraag een Gratis account aan en zie voor jezelf hoe Solvere jouw
            organisatie kan vereenvoudigen!
          </p>
          <p className="text-[20px] text-[#666666] mx-auto mb-8">
            Wij wensen u alvast veel genot met uw vrije tijd.
          </p>

          <div className="flex justify-center">
            <RFTrigger />
          </div>
        </div>
      </section>
    </div>
  );
};
export default OverOns;
